export const getFormattedDisplayValue = (systemValue: string) => {
  return systemValue.split('::').pop() ?? systemValue;
};
